import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'page-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
